import { Pencil, Trash2 } from 'lucide-react';
import { Button } from '@/components/ui';

export function CrudActions({
  onEdit,
  onDelete,
  deleteLabel = 'Sil',
}: {
  onEdit?: () => void;
  onDelete?: () => void;
  deleteLabel?: string;
}) {
  return (
    <div className="flex gap-1">
      {onEdit && (
        <Button type="button" size="sm" variant="outline" onClick={onEdit} aria-label="Düzenle">
          <Pencil className="h-3.5 w-3.5" />
        </Button>
      )}
      {onDelete && (
        <Button
          type="button"
          size="sm"
          variant="ghost"
          onClick={onDelete}
          className="text-destructive hover:bg-red-50"
          aria-label={deleteLabel}
        >
          <Trash2 className="h-3.5 w-3.5" />
        </Button>
      )}
    </div>
  );
}
